import { openMetadataApiClient } from '@/shared/api/core/axios-instance';
import type { JsonPatchOperation } from '@/shared/types/common';

import type { GlossaryCategoryItem } from '@/entities/glossary';

type UpdateGlossaryCategoryRequest = {
  glossaryId: string;
  operations: JsonPatchOperation[];
};

export const updateGlossaryCategoryApi = async ({
  glossaryId,
  operations,
}: UpdateGlossaryCategoryRequest): Promise<GlossaryCategoryItem> => {
  try {
    const { data } = await openMetadataApiClient.patch<GlossaryCategoryItem>(`/glossaries/${glossaryId}`, operations, {
      headers: {
        'Content-Type': 'application/json-patch+json',
      },
    });
    return data;
  } catch (error) {
    console.error('Failed to update glossary category:', error);
    throw error;
  }
};

export type { UpdateGlossaryCategoryRequest };
